<template lang="pug">
.user-create-by-admin-form
  v-dialog(v-model="dialog")
    v-card
      v-card-title.title {{ dialogTitle }}
      v-card-text
        template(v-for="(item, index) in dialogContent")
          base-text-divider 重複名字之會員{{ index + 1 }}
          base-field(
            label="姓名"
            :value="item.displayName")
          base-field(
            label="地區"
            :value="REGIONS[item.region].text")
          base-field(
            label="生日"
            :value="item.birth | timestampFilter")
          base-field(
            label="地址"
            :value="item.address")
          base-field(
            label="電話"
            :value="item.phoneNumber")
      v-card-actions.text-xs-center
        v-btn(
          color="indigo"
          outline
          block
          @click="dialog = false") 確認
  v-form(
    ref="form"
    v-model="valid"
    lazy-validation)
    v-container
      base-text-divider 必填欄位
      v-layout(wrap)
        v-flex(
          xs12
          sm6)
          v-text-field(
            v-model="firstName"
            label="姓*"
            outline
            required)
        v-flex(
          xs12
          sm6)
          v-text-field(
            v-model="lastName"
            :error-messages="lastNameErrors"
            label="名*"
            outline
            required
            @input="$v.lastName.$touch()"
            @blur="$v.lastName.$touch()")
        v-flex(xs12)
          v-btn(
            outline
            block
            large
            color="warning"
            @click="check") 檢查姓名
        v-flex(
          xs12
          sm6)
          v-select(
            v-model="region"
            :items="regionItems"
            :error-messages="regionErrors"
            item-value="value"
            item-text="text"
            label="地區*"
            outline
            @input="$v.region.$touch()"
            @blur="$v.region.$touch()")
        v-flex(
          xs12
          sm6)
          v-select(
            v-model="gender"
            :items="genderItems"
            :error-messages="genderErrors"
            item-value="value"
            item-text="text"
            label="性別*"
            outline
            required
            @input="$v.gender.$touch()"
            @blur="$v.gender.$touch()")
      BaseTextDivider 選填欄位
      v-layout(wrap)
        v-flex(
          xs12
          sm2)
          v-menu(
            ref="birthMenu"
            v-model="birthMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="birthValue"
            lazy
            offset-y
            full-width
            min-width="290px")
            template(v-slot:activator="{ on }")
              v-text-field(
                v-model="birthValue"
                label="生日"
                outline
                readonly
                v-on="on")
            v-date-picker(
              v-model="birthValue"
              ref="birthPicker"
              locale="zh-TW"
              min="1900-1-1"
              :max="new Date().toISOString().substr(0, 10)"
              :year-format="yearFormatter"
              no-title
              scrollable
              @change="saveBirth")
              v-spacer
              v-btn(
                flat
                color="error"
                @click="birthMenu = false") 取消
        v-flex(
          xs12
          sm4)
          v-text-field(
            v-model="email"
            :counter="40"
            :error-messages="emailErrors"
            label="電子信箱"
            outline
            @input="$v.email.$touch()"
            @blur="$v.email.$touch()")
        v-flex(
          xs12
          sm4)
          v-text-field(
            v-model="address"
            :counter="60"
            :error-messages="addressErrors"
            label="地址"
            outline
            @input="$v.address.$touch()"
            @blur="$v.address.$touch()")
        v-flex(
          xs12
          sm2)
          v-text-field(
            v-model="zipCode"
            :counter="3"
            :error-messages="zipCodeErrors"
            label="郵遞區號"
            outline
            @input="$v.zipCode.$touch()"
            @blur="$v.zipCode.$touch()")
      v-layout(wrap)
        v-flex(xs12)
          v-text-field(
            v-model="phoneNumber"
            :counter="10"
            :error-messages="phoneNumberErrors"
            label="電話"
            outline
            @input="$v.phoneNumber.$touch()"
            @blur="$v.phoneNumber.$touch()")
        v-flex(xs12)
          v-text-field(
            v-model="phoneNumber_2"
            :counter="10"
            :error-messages="phoneNumber_2Errors"
            label="電話2"
            outline
            @input="$v.phoneNumber_2.$touch()"
            @blur="$v.phoneNumber_2.$touch()")
      v-layout(wrap)
        v-flex(
          xs12
          sm6)
          v-combobox(
            v-model="jobs"
            label="職稱"
            outline
            multiple
            small-chips
            deletable-chips
            hide-selected)
        v-flex(
          xs12
          sm3)
          v-text-field(
            v-model="homeland"
            :counter="10"
            :error-messages="homelandErrors"
            label="家鄉"
            outline
            @input="$v.homeland.$touch()"
            @blur="$v.homeland.$touch()")
        v-flex(
          xs12
          sm3)
          v-text-field(
            v-model="career"
            :counter="20"
            :error-messages="careerErrors"
            label="職業"
            outline
            @input="$v.career.$touch()"
            @blur="$v.career.$touch()")
        v-flex(xs12)
          v-text-field(
            v-model="referrer"
            :counter="16"
            :error-messages="referrerErrors"
            label="推薦人"
            outline
            @input="$v.referrer.$touch()"
            @blur="$v.referrer.$touch()")
        v-flex(xs12)
          v-menu(
            ref="joinTimeMenu"
            v-model="joinTimeMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            :return-value.sync="joinTimeValue"
            lazy
            offset-y
            full-width
            min-width="290px")
            template(v-slot:activator="{ on }")
              v-text-field(
                v-model="joinTimeValue"
                label="入會日期"
                readonly
                outline
                v-on="on")
            v-date-picker(
              v-model="joinTimeValue"
              ref="joinTimePicker"
              locale="zh-TW"
              min="1900-1-1"
              :max="new Date().toISOString().substr(0, 10)"
              no-title
              scrollable
              @change="saveJoinTime")
              v-spacer
              v-btn(
                flat
                color="error"
                @click="joinTimeMenu = false") 取消
      v-layout
        v-flex(xs12)
          v-text-field(
            v-model="remarks"
            :counter="1000"
            :error-messages="remarksErrors"
            label="備註"
            outline
            @input="$v.remarks.$touch()"
            @blur="$v.remarks.$touch()")
      v-layout
        v-flex(xs6)
          v-text-field(
            v-model="tshirtSize"
            label="衣服尺寸"
            outline
            @input="$v.tshirtSize.$touch()"
            @blur="$v.tshirtSize.$touch()")
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength, email, numeric } from "vuelidate/lib/validators";
import { mapGetters, mapActions } from "vuex";
import REGIONS from "@/assets/tables/regions.json";
import GENDERS from "@/assets/tables/genders.json";
import { length } from "@/utils/validators";
import formBuilder from "@/utils/formBuilder";
import BaseTextDivider from "@/components/core/BaseTextDivider.vue";
import BaseField from "@/components/core/BaseField.vue";
import { db } from "@/firebase";

export default {
  name: "UserCreateByAdminForm",
  mixins: [validationMixin],
  validations: {
    lastName: { required },
    region: { required },
    gender: { required },
    email: { email, maxLength: maxLength(40) },
    address: { maxLength: maxLength(60) },
    zipCode: { numeric, length: length(3) },
    phoneNumber: { numeric, maxLength: maxLength(10) },
    phoneNumber_2: { numeric, maxLength: maxLength(10) },
    homeland: { maxLength: maxLength(10) },
    career: { maxLength: maxLength(20) },
    referrer: { maxLength: maxLength(16) },
    remarks: { maxLength: maxLength(1000) },
    tshirtSize: {}
  },
  components: {
    BaseTextDivider,
    BaseField
  },
  data() {
    return {
      REGIONS,
      regionItems: Object.entries(REGIONS).map(v => v[1]),
      genderItems: Object.entries(GENDERS).map(v => v[1]),
      valid: null,
      birthMenu: false,
      birthValue: null,
      joinTimeMenu: false,
      joinTimeValue: null,
      firstName: null,
      lastName: null,
      region: null,
      gender: null,
      email: null,
      address: null,
      zipCode: null,
      phoneNumber: null,
      phoneNumber_2: null,
      jobs: null,
      homeland: null,
      career: null,
      referrer: null,
      remarks: null,
      tshirtSize: null,
      loading: false,
      message: "",
      successAlert: false,
      successMessage: "",
      dialog: false,
      dialogTitle: null,
      dialogContent: null
    };
  },
  computed: {
    birth() {
      return this.birthValue ? new Date(this.birthValue) : "";
    },
    joinTime() {
      return this.joinTimeValue ? new Date(this.joinTimeValue) : "";
    },
    lastNameErrors() {
      const errors = [];
      if (!this.$v.lastName.$dirty) return errors;
      !this.$v.lastName.required && errors.push("必填名字");
      return errors;
    },
    regionErrors() {
      const errors = [];
      if (!this.$v.region.$dirty) return errors;
      !this.$v.region.required && errors.push("必填所屬區域");
      return errors;
    },
    genderErrors() {
      const errors = [];
      if (!this.$v.gender.$dirty) return errors;
      !this.$v.gender.required && errors.push("必填性別");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("電子信箱格式錯誤");
      !this.$v.email.maxLength && errors.push("最多40個字母");
      return errors;
    },
    addressErrors() {
      const errors = [];
      if (!this.$v.address.$dirty) return errors;
      !this.$v.address.maxLength && errors.push("最多60個字");
      return errors;
    },
    zipCodeErrors() {
      const errors = [];
      if (!this.$v.zipCode.$dirty) return errors;
      !this.$v.zipCode.numeric && errors.push("請輸入數字");
      !this.$v.zipCode.length && errors.push("請輸入郵遞區號3碼");
      return errors;
    },
    phoneNumberErrors() {
      const errors = [];
      if (!this.$v.phoneNumber.$dirty) return errors;
      !this.$v.phoneNumber.numeric && errors.push("請輸入數字");
      !this.$v.phoneNumber.maxLength && errors.push("最多10個數字");
      return errors;
    },
    phoneNumber_2Errors() {
      const errors = [];
      if (!this.$v.phoneNumber_2.$dirty) return errors;
      !this.$v.phoneNumber_2.numeric && errors.push("請輸入數字");
      !this.$v.phoneNumber_2.maxLength && errors.push("最多10個數字");
      return errors;
    },
    homelandErrors() {
      const errors = [];
      if (!this.$v.homeland.$dirty) return errors;
      !this.$v.homeland.maxLength && errors.push("最多10個字");
      return errors;
    },
    careerErrors() {
      const errors = [];
      if (!this.$v.career.$dirty) return errors;
      !this.$v.career.maxLength && errors.push("最多20個字");
      return errors;
    },
    referrerErrors() {
      const errors = [];
      if (!this.$v.referrer.$dirty) return errors;
      !this.$v.referrer.maxLength && errors.push("最多16個字");
      return errors;
    },
    remarksErrors() {
      const errors = [];
      if (!this.$v.remarks.$dirty) return errors;
      !this.$v.remarks.maxLength && errors.push("最多1000個字");
      return errors;
    }
  },
  watch: {
    birthMenu(val) {
      val && setTimeout(() => (this.$refs.birthPicker.activePicker = "YEAR"));
    },
    joinTimeMenu(val) {
      val &&
        setTimeout(() => (this.$refs.joinTimePicker.activePicker = "YEAR"));
    }
  },
  methods: {
    ...mapActions(["api"]),
    saveBirth(date) {
      this.$refs.birthMenu.save(date);
    },
    saveJoinTime(date) {
      this.$refs.joinTimeMenu.save(date);
    },
    reset() {
      this.$refs.form.reset();
      this.$v.$reset();
    },
    getFormData() {
      const fields = [
        "firstName",
        "lastName",
        "region",
        "gender",
        "birth",
        "email",
        "address",
        "zipCode",
        "phoneNumber",
        "phoneNumber_2",
        "jobs",
        "homeland",
        "career",
        "joinTime",
        "referrer",
        "remarks",
        "tshirtSize"
      ];
      return formBuilder(fields, this);
    },
    async submit() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return false;
      }

      return await this.api({
        method: "post",
        url: "user",
        data: this.getFormData()
      });
    },
    async check() {
      this.dialogContent = null;

      const displayName = `${this.firstName}${this.lastName}`.trim();
      const snap = await db
        .collection("users")
        .where("displayName", "==", displayName)
        .get();

      if (snap.size === 0) {
        this.dialogTitle = "沒有重複名字的會員";
      } else {
        const items = [];
        snap.docs.forEach(doc => {
          items.push(doc.data());
        });
        this.dialogTitle = "已有以下重複名字的會員";
        this.dialogContent = items;
      }

      this.dialog = true;
    },
    yearFormatter(v) {
      return `民國 ${v - 1911} (${v})`;
    }
  }
};
</script>
